import Papa from 'papaparse';

export function downloadCsvFile<T extends object>(
  data: T[],
  filename: string,
  {
    escapeFormulae = false,
    fields,
  }: { escapeFormulae?: boolean; fields?: string[] } = {},
) {
  // With `fields` the header row is written even when there are no rows.
  const csv = fields
    ? Papa.unparse<unknown[]>(
        {
          fields,
          data: data.map((row) =>
            fields.map((field) => (row as Record<string, unknown>)[field]),
          ),
        },
        { escapeFormulae },
      )
    : Papa.unparse(data, { escapeFormulae });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
